import type { EntityStatus } from '@core';
import type { IncidentSeverity } from '@models';

export interface Space {
  createdOn: string;
  devicesByStatuses: {
    activeCount: number;
    deactivatedCount: number;
    pausedCount: number;
  };
  devicesCount: number;
  documentReference: string;
  externalReference: string;
  friendlyName: string;
  id: string;
  incidentCountBySeverity: Record<IncidentSeverity, number>;
  locationId: string;
  name: string;
  parentSpace?: Space;
  parentSpaceId: string | null;
  position?: number;
  status: EntityStatus;
  type: SpaceType;
  unstructuredDataReference: string;
  virtualRoomId?: string | null;
}

export enum SpaceType {
  room = 'Room',
  floor = 'Floor',
}

export interface FloorSpaceModel extends Space {
  floorplan?: string;
  rooms?: RoomSpaceModel[];
  type: SpaceType.floor;
}

export interface RoomSpaceModel extends Space {
  type: SpaceType.room;
}
